import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import "./AllAtmForm.css";
import {
  getData,
  putDataWithBody,
  postDataWithBody,
} from "../../../../Services/Services";
import {
  deleteAtm,
  findRegionsByUser,
  getallBanksByRole,
  getatmalldetailsByRole,
  getbarches,
  getThemeURL,
} from "../../../../Services/EndPoints";
import Table from "../../../../Components/UiComponents/Table/Table";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import {
  Viewicon,
  DeleteConvgIcon,
  EditConvgIcon,
} from "../../../../Components/IconComponents";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { useDispatch } from "react-redux";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { atmManagementcolumnsForExport } from "../../../../JsonData/ATMManagementConfig";

// Component rendering all ATM details in tabular view
const AllAtmForm = () => {
  const [allatmdata, setallatmdata] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const itemsPerPage = 10;
  const [searchText, setSearchText] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [banksList, setBanksList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [districts, setDistricts] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedATM, setSelectedATM] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [userPermissions, setUserPermissions] = useState({
    canView: false,
    canEdit: false,
    canDelete: false,
  });

  // Modal handlers
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = (atm) => {
    setSelectedATM(atm);
    setShowModal(true);
  };
  //UseEffect for loading Initial user and district data
  useEffect(() => {
    getUserProfileForATM();
    getUserProfile();
    fetchdistricts();
    fetchuerProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  // Update filtered data when search text or district changes
  useEffect(() => {
    filterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, selectedDistrict, allatmdata]);
  const fetchuerProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  //ATM filtered data function for search and district dropdown
  const filterData = () => {
    let filtered = [...allatmdata];

    // Filter by search text
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      filtered = filtered.filter(
        (atm) =>
          atm.name?.toLowerCase().includes(searchLower) ||
          atm.code?.toLowerCase().includes(searchLower) ||
          atm.city?.toLowerCase().includes(searchLower) ||
          atm.district?.toLowerCase().includes(searchLower) ||
          atm.addressLine?.toLowerCase().includes(searchLower) ||
          atm.pinCode?.toString().includes(searchLower)
      );
    }

    // Filter by district
    if (selectedDistrict) {
      filtered = filtered.filter((atm) => atm.district === selectedDistrict);
    }

    setFilteredData(filtered);
    setRowCount(filtered.length);
  };

  // Parse web permissions from user profile
  const parseUserPermissions = (permissions) => {
    if (!permissions || !Array.isArray(permissions)) {
      return { canView: false, canEdit: false, canDelete: false };
    }

    // Find the permission with ID 5 for "All Branches" functionality
    const hasPermission = permissions.find((permission) => permission.id === 9);
    console.log("permission found:", hasPermission);

    if (!hasPermission || !hasPermission.web_permissions) {
      return { canView: false, canEdit: false, canDelete: false };
    }

    // Parse web_permissions string (e.g., "V,E,D" or "V" or "V,E")
    const webPermissions = hasPermission.web_permissions
      .split(",")
      .map((p) => p.trim());

    const result = {
      canView: webPermissions.includes("V"),
      canEdit: webPermissions.includes("E"),
      canDelete: webPermissions.includes("D"),
    };

    return result;
  };

  //Get User profile call for ATM role based details
  const getUserProfileForATM = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      console.log("User Profile:", userProfile);
      if (userProfile && userProfile.length > 0) {
        getallATMdata(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayloadForATM = (profile) => {
    let admin_role;

    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  //Get All ATM Data based on user role Api call
  const getallATMdata = async (profile) => {
    try {
      const payload = createPayloadForATM(profile);
      const response = await postDataWithBody(
        getatmalldetailsByRole,
        payload,
        {}
      );
      if (response && Array.isArray(response)) {
        setallatmdata(response);
        setFilteredData(response);
        setRowCount(response.length);
        sendDataToCentralStore(response);
      }
    } catch (error) {
      toast.error("Failed to load ATM data");
    }
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        // Check if user is SUPER ADMIN
        const isSuper = userProfile[0].role_name === "SUPER ADMIN";
        setIsSuperAdmin(isSuper);
        // Parse and set user permissions
        const permissions = parseUserPermissions(userProfile[0].permissions);
        setUserPermissions(permissions);
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };
  //Payload for bank data based on role
  const createPayload = (profile) => {
    let admin_role;

    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  // Fetch Bank details Api call
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
        fetchBranches(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    }
  };
  // Fetch Branch details Api call
  const fetchBranches = async (banks) => {
    try {
      const branchRequests = banks.map((bank) => {
        return getData(getbarches.replace("ID", bank.id));
      });

      const responses = await Promise.all(branchRequests);

      let allBranches = [];
      responses.forEach((response) => {
        if (response && Array.isArray(response)) {
          allBranches = [...allBranches, ...response];
        }
      });

      setBranches(allBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
      toast.error("Failed to load branches data");
    }
  };

  const fetchdistricts = async () => {
    try {
      const response = await getData(findRegionsByUser);
      if (response && Array.isArray(response)) {
        setDistricts(response);
      } else {
        toast.error("Failed to load districts data");
      }
    } catch (error) {
      toast.error("Error fetching districts");
    }
  };

  const handleViewATM = (atm) => {
    // Find the associated bank and branch
    const bank = banksList.find((bank) => bank.id === atm.bankId);
    const branch = branches.find((branch) => branch.id === atm.branchId);

    // Navigate to ATM details view with data
    navigate("/add-atm/atm-details", {
      state: {
        atm,
        bank,
        branch,
      },
    });
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = atmManagementcolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  //Columns for mapping the table data
  const columns = React.useMemo(
    () => [
      {
        Header: t("S.No."),
        accessor: (row, index) => index + 1,
        disableSortBy: true,
        Cell: ({ row }) => {
          return <span>{row.index + 1}</span>;
        },
      },
      {
        Header: t("ATM Name"),
        accessor: "name",
        disableSortBy: false,
      },
      {
        Header: t("ATM Code"),
        accessor: "code",
        disableSortBy: true,
      },
      {
        Header: t("Bank Name"),
        accessor: "bankName",
        disableSortBy: true,
        Cell: ({ row }) => {
          const bankId = row.original.bankId;
          const bank = banksList.find((bank) => bank.id === bankId);
          return bank ? bank.bankName : "NA";
        },
      },
      {
        Header: t("Branch Name"),
        accessor: "branchName",
        disableSortBy: true,
        Cell: ({ row }) => {
          const branchId = row.original.branchId;
          const branch = branches.find((branch) => branch.id === branchId);
          return branch ? branch.branchName : "NA";
        },
      },
      {
        Header: t("City"),
        accessor: "city",
        disableSortBy: false,
      },
      {
        Header: t("District"),
        accessor: "district",
        disableSortBy: false,
      },
      {
        Header: t("Address"),
        accessor: "addressLine",
        disableSortBy: true,
        Cell: ({ row }) => {
          return <span>{row.original.addressLine || "NA"}</span>;
        },
      },
      {
        Header: t("Active Status"),
        accessor: "activeStatus",
        disableSortBy: true,
        Cell: ({ value }) => {
          return value ? (
            <div
              style={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "20px",
                height: "20px",
                borderRadius: "4px",
                backgroundColor: "#15D1A4",
              }}
            >
              ✓
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "#FF5733",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                width: "20px",
                height: "20px",
              }}
            >
              ✕
            </div>
          );
        },
      },
      {
        Header: t("sopinstancelist.action"),
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <div
              className="usertable__actionsicon"
              style={{ display: "flex", gap: "10px" }}
            >
              {/* View ATM */}
              {userPermissions.canView && (
                <span onClick={() => handleViewATM(row.original)}>
                  <Viewicon className="cursor-pointer me-2" />
                </span>
              )}

              {/* Edit ATM */}
              {userPermissions.canEdit && (
                <span
                  onClick={() => {
                    navigate("../add-atms", {
                      state: { data: row.original, edit: true },
                    });
                  }}
                >
                  <EditConvgIcon className="cursor-pointer me-2" />
                </span>
              )}

              {/* Delete ATM */}
              {userPermissions.canDelete && (
                <span
                  onClick={() => handleShowModal(row.original)}
                  className="cursor-pointer"
                >
                  <DeleteConvgIcon className="cursor-pointer mr-1" />
                </span>
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, navigate, banksList, branches, userPermissions]
  );
  //Delete ATM details Handler
  const handleDeleteATM = async (atmData) => {
    try {
      let intput = {
        id: atmData.id,
        name: atmData.name,
        district: atmData.district,
        code: atmData.code,
        activeStatus: atmData.activeStatus,
        entryDate: atmData.entryDate,
        addressLine: atmData.addressLine,
        pinCode: atmData.pinCode,
        city: atmData.city,
        mandal: atmData.mandal,
        latitude: atmData.latitude,
        longitude: atmData.longitude,
        updated_by: userId,
        bankId: atmData.bankId,
        branchId: atmData.branchId,
        remarks: "",
      };
      const response = await putDataWithBody(deleteAtm, intput, {});
      if (response.status === "success") {
        toast.success(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        handleCloseModal();
        // Refresh the ATM data
        getUserProfileForATM();
      } else {
        toast.error(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        handleCloseModal();
        // Refresh the ATM data
        getUserProfileForATM();
      }
    } catch (error) {}
  };

  return (
    <div className="atm-table-container">
      <div className="branch-main-container-forAtm">
        <div
          className="d-flex align-items-center gap-4"
          style={{
            justifyContent: "space-between",
            padding: "10px",
            height: "45px",
          }}
        >
          {/* Total ATMs Button */}
          <label
            style={{
              backgroundColor: "#1a7a73",
              color: "#FFFFFF",
              fontWeight: "Bold",
              fontSize: "12px",
              fontFamily: "Poppins",
              height: "29px",
              padding: "6px 6px",
              borderRadius: "4px",
              marginTop: "6px",
              marginLeft: "12px",
              width: "102px",
            }}
          >
            Total ATMs: {filteredData.length}
          </label>
          {/* District filter dropdown - Only show for SUPER ADMIN */}
          {isSuperAdmin && (
            <div
              className="d-flex align-items-center"
              style={{ gap: "5px", marginLeft: "400px" }}
            >
              <label
                style={{
                  width: "60px",
                  color: "#969FA8",
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  fontWeight: "400",
                }}
              >
                Sort by:
              </label>
              <select
                className="pl-4 pr-8 border appearance-none text-sm w-36"
                value={selectedDistrict}
                onChange={(e) => setSelectedDistrict(e.target.value)}
                style={{
                  color: "#000000",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  height: "29px",
                  borderRadius: "4px",
                }}
              >
                <option value="" style={{ marginTop: "5px" }}>
                  All Districts
                </option>
                {districts.map((district) => (
                  <option key={district.id} value={district.value}>
                    {district.value}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* Search Input */}
          <div
            className="d-flex align-items-center shadow-sm rounded-2"
            style={{
              maxWidth: "250px",
              marginLeft: 15,
              backgroundColor: "white",
              height: "29px",
              padding: "0 8px",
              marginRight: "13px",
            }}
          >
            <input
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                height: "29px",
                backgroundColor: "#FFFFFF",
                border: "none",
                outline: "none",
                boxShadow: "none",
                padding: 0,
                margin: 0,
                flex: 1,
                color: "#67717A",
                fontSize: "14px",
                fontFamily: "Poppins",
              }}
            />
            <Search
              style={{ height: "12px", width: "12px", color: "#1a7a73" }}
            />
          </div>
        </div>
      </div>

      <div className="datatable__container p-1">
        <Table
          data={filteredData}
          title=""
          showFilter={false}
          setSearchData={setSearchData}
          columns={columns}
          numberOfRows={itemsPerPage}
          showExport={false}
          showReset={false}
          onExpand={false}
          showSearch={false}
          isHeaderFixed={true}
          rowCount={rowCount}
          headerTableHeadStyle={{ background: "#1a7a73", color: "#FFFFFF" }}
          tableStyle={{
            border: "1px solid  #f0f0f0",
            borderRadius: "4px",
            marginTop: "-15px",
            padding: "0px",
          }}
        />
      </div>

      {/* Delete Confirmation Modal - Using React Bootstrap Modal correctly */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedATM && selectedATM.activeStatus === true
              ? "Deactivate ATM?"
              : "Delete ATM?"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedATM && (
            <p>
              {selectedATM.activeStatus === true
                ? "This ATM is currently active. Are you sure you want to deactivate it?"
                : "This ATM is already inactive. Do you want to delete it permanently?"}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "#1a7a73" }}
            onClick={() => selectedATM && handleDeleteATM(selectedATM)}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AllAtmForm;
